import { graphql } from '@api/highnote'

export const GET_DOCUMENT_UPLOAD_SESSION = graphql(`
  query GetDocumentUploadBySessionID($sessionId: ID!) {
    node(id: $sessionId) {
      __typename
      ... on USAccountHolderApplicationDocumentUploadSession {
        __typename
        id
        status
        primaryDocumentTypes
        uploadRequirements {
          constraints {
            ... on DocumentUploadRequirementConstraint {
              documentType
              numberOfDocuments
            }
          }
        }
        documents {
          ... on DocumentUploadLink {
            id
            status
            documentCategoryType
            documentType
            status
            documentUploadSession {
              id
              status
            }
          }
        }
      }
    }
  }
`)
